import { format, parseISO } from 'date-fns';

import { IArchivedMedicaidPlan } from '~/services/api/medicaidPlan/types';
import { generalDateAtTime } from '~/ui/constants/dateFormat';

const formatArchivedBy = ({ archivedBy, archivedOn }: IArchivedMedicaidPlan): string =>
  `Archived${archivedBy ? ` by ${archivedBy}` : ''} on ${format(
    parseISO(archivedOn),
    generalDateAtTime,
  )}`;

export default formatArchivedBy;
